export const pages = {
	'boltSplashHub': { id: 'boltSplashHub', page: 'splashHub', getter: () => import(/* webpackChunkName: 'splashHub' */ 'components/bolt/splashHub/splashHub') }
};
export const sections = [

];
